<!--
  src/App.vue
-->

<template>
  <v-app>
    <v-app-bar app color="white" class="elevation-0">
      <img v-if="login == null" src="../public/logo.png" width="28px" class="mr-3">
      <v-toolbar-title v-if="login == null" class="primary--text">
        BalletFIT Korea
      </v-toolbar-title>
      <v-app-bar-nav-icon v-if="login" @click="drawer = !drawer" />
      <v-spacer />
      <v-toolbar-title v-if="login" class="primary--text title-center">
        <img class="mr-3" src="../public/logo.png" width="28px" /> {{title}}
      </v-toolbar-title>
      <v-spacer />
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app v-if="login">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            BalletFIT Korea
          </v-list-item-title>
          <v-list-item-subtitle>
            {{subtitle}}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list dense nav >
        <v-row class="pa-3">
          <v-list-item link :to="'/'">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title><span class="font-14">수업 안내</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="menu in menus" :key="menu.title" link :to="menu.to">
            <v-list-item-icon>
              <v-icon>{{ menu.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title><span class="font-14">{{ menu.title }}</span></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-row>
        <v-divider class="mt-3 mb-3" />
        <v-list-item link :to="'/modify'">
          <v-list-item-icon>
            <v-icon>mdi-account-edit</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title><span class="font-14">내 정보 수정</span></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-account-arrow-right</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title><span class="font-14">로그아웃</span></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-divider />
      <v-container fluid>
        <router-view @login="setLogin"/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data () {
    return {
      login: null,
      title: null,
      subtitle: null,
      drawer: false,
      menus: [
        { title: '수업 예약', icon: 'mdi-clock', to: '/booking' },
        { title: '쿠폰 정보', icon: 'mdi-account-cash', to: '/coupon' },
      ],
    }
  },

  methods: {
    setLogin: function (login) {
      this.drawer = false
      this.login = login
      if (this.login) {
        this.title = this.login.name + ' (' + this.login.studio_name + ')'
        this.subtitle = '예약 어플리케이션'
      }
      else {
        this.title = null
      }
    },

    logout: function () {
      if (confirm('정말로 로그아웃 하시겠습니까?')) {
        this.login = null
        localStorage.setItem('login', '')
        this.$router.push('/login')
      }
    }
  },
  
  created () {
    console.log('App started')
  }
}
</script>

<style scoped>
.title-center {
  display: flex;
  align-items: center;
}
.font-14 {
  font-size: 14px;
}
</style>
